import React from "react";

const Spinner = () => {
  return <div id="loader"></div>;
};

export default Spinner;
